<template>
    <v-card width="100%" height="100vh" class="tsandcs-container d-flex flex-column">
        <div><banner></banner></div>
        <v-card-title class="headline grey lighten-2">
            Terms and Conditions
        </v-card-title>

        <v-card-text class="mb-auto pt-2 mb-5" style="overflow-y: scroll; padding-bottom: 82px;">
            <div class="terms-copy" v-html="terms_copy"></div>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions class="back-container d-flex flex-column pa-3">
            <v-btn small color="primary" to="/tsandcs">Back</v-btn>
        </v-card-actions>
    </v-card>
</template>

<script>
import {mapGetters} from "vuex";
import Banner from "@/components/Banner";

export default {
    components: {Banner},
    mounted () {
        this.$store.dispatch('challenge/getTerms')
    },
    name: "ViewTsAndCs",
    computed: {
        ...mapGetters({
            terms_copy: 'challenge/termsCopy',
        })
    }
}
</script>

<style lang="scss">

.terms-copy {
  margin-top: 16px;
  p:last-child {
    margin-bottom: 0;
  }
  .level-1 {
    font-weight: bold;
    display: flex;
  }
  .point-number {
    width: 40px;
  }
  .point {
    width: 97%;
  }
  .level-2 {
    display: flex;
    .level-3 {
      display: flex;
    }
  }
  .ql-indent-1:not(.ql-direction-rtl) {
    padding-left: 3em;
  }
  ol {

    margin: 0;
    padding: 0;
    padding-left: 0 !important;
    counter-reset: list-1 list-2 list-3 list-4 list-5 list-6 list-7 list-8 list-9;

    & > li {
      list-style-type: none;
      counter-reset: list-1 list-2 list-3 list-4 list-5 list-6 list-7 list-8 list-9;
      counter-increment: list-0;
    }

    li.ql-indent-1 {
      counter-reset: list-2 list-3 list-4 list-5 list-6 list-7 list-8 list-9;
      counter-increment: list-1;
    }

    li.ql-indent-2 {
      counter-reset: list-3 list-4 list-5 list-6 list-7 list-8 list-9;
      counter-increment: list-2;
    }

    li:before {
      content: counter(list-0, decimal) '. ';
      display: inline-block;
      white-space: nowrap;
      width: 1.2em;
    }

    list-style-type: none;
    li:not(.ql-direction-rtl), li.ql-indent-1:not(.ql-direction-rtl) {
      padding-left: 3em;

    }
    li.ql-indent-2:not(.ql-direction-rtl) {
      padding-left: 6em;
    }
    li:not(.ql-indent-1, .ql-indent-2) {
      &:before {
        font-weight: bold;
      }
    }
    li.ql-indent-1 {
      &:before {
        content: counter(list-0, decimal) '.' counter(list-1, decimal);
      }
    }
    li.ql-indent-2 {
      &:before {
        content: '(' counter(list-2, lower-alpha) ')';
      }
    }
    li:not(.ql-direction-rtl)::before {
      margin-left: -3em;
      margin-right: 0;
      text-align: right;
      padding-right: 3em;
    }
    li:not(:first-child, .ql-indent-1, .ql-indent-2) {
      margin-top: 1.5em;
    }
  }

  li, p {
    margin-top: .5em;
  }


}

.radio-options {
  display: flex;
  div.radio {
    margin-right: 5px;
    label {
      margin-left: 5px;
    }
  }
}

.confirm-btn {
  display: block;
}

.back-container {
    position: fixed;
    align-items: center;
    bottom: 0;
    left: 0;
    width: 100%;
    background: #FFFFFF;
  }
</style>
